import { ExampleLabel } from "./ExampleLabel";

export function Rewards() {
  return (
    <section className="sec card" id="gaming">
      <div className="gaming">
        <div className="gaming-copy">
          <div className="eyebrow" style={{ color: "var(--voy-purple-200)" }}>
            <span className="dot" style={{ background: "var(--voy-purple-200)" }} /> Rewards · Coming soon
          </div>
          <h2>
            Book more. <span className="italic">Fly further.</span>
          </h2>
          <p>
            Every dollar saved becomes points. Points unlock lounge passes, seat upgrades, Companion perks, not a fake
            airline currency.
          </p>
          <div style={{ marginTop: 26 }}>
            <ExampleLabel />
            <div className="gaming-stats" style={{ marginTop: 0 }}>
              <div className="g-item"><div className="n">12,400</div><div className="l">Your points</div></div>
              <div className="g-item"><div className="n">Lv. 3</div><div className="l">Voyager tier</div></div>
              <div className="g-item"><div className="n">4</div><div className="l">Unlocked perks</div></div>
            </div>
          </div>
        </div>
        <div className="gaming-card">
          <ExampleLabel />
          <div className="gc-row unlocked"><span className="lvl">LV 01</span><span className="title">First-class seat selection</span><span className="pts">500 pts</span></div>
          <div className="gc-row unlocked"><span className="lvl">LV 02</span><span className="title">Priority boarding</span><span className="pts">1,200 pts</span></div>
          <div className="gc-row unlocked"><span className="lvl">LV 03</span><span className="title">Global lounge access (10 visits)</span><span className="pts">4,500 pts</span></div>
          <div className="gc-row unlocked"><span className="lvl">LV 04</span><span className="title">Free Companion upgrade · 6 mo</span><span className="pts">8,000 pts</span></div>
          <div className="gc-row locked"><span className="lvl">LV 05</span><span className="title">Business-class upgrade voucher</span><span className="pts">15,000 pts</span></div>
          <div className="gc-row locked"><span className="lvl">LV 06</span><span className="title">Companion suite · lifetime</span><span className="pts">40,000 pts</span></div>
        </div>
      </div>
    </section>
  );
}
